import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext } from 'react-oauth2-code-pkce';
import toast from "react-hot-toast";

const AuthGate = ({ children }) => {
 const { tokenData, token, login, logout, error } = useContext(AuthContext);
  const loginCalled = useRef(false);
   const hasShownSuccessToast = useRef(false);

  // Check if we are in the middle of an OAuth2 redirect
  const isOAuthRedirect = window.location.search.includes('code=');

  useEffect(() => {
    if (!token && !error && !loginCalled.current && !isOAuthRedirect) {
      loginCalled.current = true;
      login();
    }
  }, [token, error, login, isOAuthRedirect]);
  
  // 🟢 Show toast on successful login
  useEffect(() => {
    if (token) {
         const hasShown = sessionStorage.getItem("loginToastShown");
         if (!hasShown) {
           toast.success("Welcome! Login successful ");
           sessionStorage.setItem("loginToastShown", "true");
         }
    }
  }, [token]);

  if (error) return <div>Authentication error: {error}</div>;
  if (!token) return <div>Redirecting to login...</div>;

  return children;
};

export default AuthGate;